export const GET_SURVEYS = "GET_SURVEYS";
export const SURVEY_LOADING = "SURVEY_LOADING";
export const GET_SURVEY = "GET_SURVEY";
export const UPDATE_SURVEY = "UPDATE_SURVEY";
export const ADD_SURVEY = "ADD_SURVEY";
export const DELETE_SURVEY = "DELETE_SURVEY";
